export const scrollTop = () => {
    window.scrollTo(0, 0);
}

export const windowScroll = (top : number = 0) => {
    setTimeout(() => {
        window.scroll({
            top,
            left : 0,
            behavior : 'smooth'
        });
    }, 300);
}